import { Check, X, FileText, ImageIcon, Link2 } from "lucide-react";
import { API } from "@/lib/api";
import { fmtDate } from "@/components/admin/AdminTables";

const STATUS_BADGES = {
  pending: { label: "À valider", className: "bg-yellow-100 text-yellow-700" },
  approved: { label: "Publié", className: "bg-emerald-100 text-emerald-700" },
  rejected: { label: "Refusé", className: "bg-red-100 text-red-600" },
};

export const ArticlesList = ({ submissions, onDecide }) => (
  <div className="grid gap-4" data-testid="admin-articles-list">
    {submissions.map((s) => (
      <div key={s.id} className="card-soft p-6" data-testid={`admin-article-${s.id}`}>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="font-display font-bold text-slate-900">{s.title}</div>
          <span className={`text-xs font-bold uppercase tracking-widest rounded-full px-2.5 py-1 ${(STATUS_BADGES[s.status] || STATUS_BADGES.rejected).className}`}>
            {(STATUS_BADGES[s.status] || STATUS_BADGES.rejected).label}
          </span>
        </div>
        <div className="text-xs text-slate-500 mt-1">
          Par {s.author_name}{s.author_role ? ` — ${s.author_role}` : ""} · <a href={`mailto:${s.author_email}`} className="text-brand-700 hover:underline">{s.author_email}</a> · {fmtDate(s.created_at)}
        </div>
        <p className="text-sm text-slate-700 mt-3 leading-relaxed whitespace-pre-line">{s.content}</p>
        {s.status === "pending" && (
          <div className="mt-4 flex gap-2">
            <button data-testid={`admin-approve-${s.id}`} onClick={() => onDecide(s.id, "approve")} className="inline-flex items-center gap-1.5 rounded-full bg-emerald-600 text-white px-4 py-2 text-xs font-semibold hover:bg-emerald-700">
              <Check size={13} strokeWidth={2.5} /> Publier sur le blog
            </button>
            <button data-testid={`admin-reject-${s.id}`} onClick={() => onDecide(s.id, "reject")} className="inline-flex items-center gap-1.5 rounded-full bg-slate-200 text-slate-700 px-4 py-2 text-xs font-semibold hover:bg-slate-300">
              <X size={13} strokeWidth={2.5} /> Refuser
            </button>
          </div>
        )}
      </div>
    ))}
    {!submissions.length && <div className="card-soft p-10 text-center text-slate-500">Aucun article proposé pour le moment.</div>}
  </div>
);

export const ExpertsList = ({ experts }) => (
  <div className="grid gap-4" data-testid="admin-experts-list">
    {experts.map((x) => (
      <div key={x.id} className="card-soft p-6" data-testid={`admin-expert-${x.id}`}>
        <div className="flex flex-wrap items-center justify-between gap-2">
          <div className="font-display font-bold text-slate-900">{x.name} <span className="font-normal text-slate-500">— {x.profession}</span></div>
          <div className="text-xs text-slate-500">{x.location} · {fmtDate(x.created_at)}</div>
        </div>
        <div className="text-xs text-brand-700 font-semibold mt-1">{x.expertise}{x.domains?.length ? ` · Souhaite intervenir : ${x.domains.join(", ")}` : ""}</div>
        <p className="text-sm text-slate-700 mt-3 leading-relaxed">{x.presentation}</p>
        {x.experience && <p className="text-xs text-slate-500 mt-2 leading-relaxed whitespace-pre-line">{x.experience}</p>}
        <div className="mt-4 flex flex-wrap items-center gap-3 text-xs font-semibold">
          <a href={`mailto:${x.email}`} className="text-brand-700 hover:underline">{x.email}</a>
          {x.profile_link && <a href={x.profile_link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-slate-600 hover:text-brand-700"><Link2 size={12} /> Profil professionnel</a>}
          {x.photo_file && <a href={`${API}/admin/expert-applications/${x.id}/file/photo`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-slate-600 hover:text-brand-700"><ImageIcon size={12} /> Photo</a>}
          {x.cv_file && <a href={`${API}/admin/expert-applications/${x.id}/file/cv`} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1 text-slate-600 hover:text-brand-700"><FileText size={12} /> CV</a>}
        </div>
      </div>
    ))}
    {!experts.length && <div className="card-soft p-10 text-center text-slate-500">Aucune candidature d'expert pour le moment.</div>}
  </div>
);
